import { Spinner } from '@cloudscape-design/components';

export function Loading() {
  return (
    <div className="home-page bg-[#101c2c] text-white font-sans flex flex-col h-dvh fade-out-component">
      <div className="flex flex-col flex-grow min-h-0 p-6">
        {/* <h1 className="text-3xl font-bold mb-4">Loading...</h1> */}
        {/* center spinner in middle of screen */}
        <div className="flex items-center justify-center h-full">
          <Spinner size="large" />
        </div>
      </div>
    </div>
  );
}
